/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * useAutoConnect.ts — us\1 \2ut\1 \2onnect (services/operator-web-app).
 */

import { useEffect } from 'react';
import { operatorStore } from '@/store/operatorStore';
import { appConfig } from '@/config/env';

/**
 * E2: When the main app layout mounts (after login), auto-connect to operator WebSocket
 * so events (calls, transcript, hints) are received without requiring a manual "Connect" click.
 * Only runs when currently disconnected.
 */
export function useAutoConnect(): void {
  useEffect(() => {
    const state = operatorStore.getState();
    if (state.connectionState !== 'disconnected') return;
    operatorStore.getState().connect(appConfig.wsOperatorUrl);
  }, []);
}
